import { render } from "./BovineSelector.vue?vue&type=template&id=543133dd&scoped=true"
import script from "./BovineSelector.vue?vue&type=script&lang=js"
export * from "./BovineSelector.vue?vue&type=script&lang=js"

import "./BovineSelector.vue?vue&type=style&index=0&id=543133dd&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543133dd"]])

export default __exports__